(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dior-look-section"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const sections = document.querySelectorAll('.look-section');
    if(!sections.length) return;

    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = () => matchMedia('(max-width: 980px)').matches;
    const clamp = (v,a,b) => Math.max(a, Math.min(b, v));

    /* Quick-add modal + cart add */
    if(!window.__lookSectionAddBound){
      window.__lookSectionAddBound = true;

      const fmt = function(cents){
        const v = cents / 100;
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ILS';
        const symbols = { ILS: '₪', USD: '$', EUR: '€', GBP: '£' };
        const sym = symbols[currency] || currency;
        const num = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return sym + num;
      };

      const findModal = function(){ return document.querySelector('[data-look-modal]'); };

      const openModal = async function(handle, productUrl, fallbackVariantId){
        const modal = findModal();
        if(!modal){ window.location.href = productUrl; return; }

        modal.removeAttribute('hidden');
        document.body.classList.add('look-modal-open');
        requestAnimationFrame(function(){ modal.classList.add('is-open'); });
        modal.setAttribute('aria-hidden', 'false');

        let product;
        try{
          const res = await fetch('/products/' + handle + '.js');
          if(!res.ok) throw new Error('product-fetch');
          product = await res.json();
        } catch(e){
          closeModal();
          window.location.href = productUrl;
          return;
        }

        modal.querySelector('[data-look-vendor]').textContent = product.vendor || '';
        modal.querySelector('[data-look-title]').textContent = product.title;
        modal.querySelector('.look-quick-add__image').src = product.featured_image || '';
        modal.querySelector('.look-quick-add__image').alt = product.title;
        modal.querySelector('[data-look-view]').setAttribute('href', productUrl);

        const state = {
          product: product,
          selections: {},
          variant: null
        };
        modal.__state = state;

        const optionsContainer = modal.querySelector('[data-look-options]');
        optionsContainer.innerHTML = '';

        if(product.options && product.options.length){
          product.options.forEach(function(optionRaw, optIndex){
            const optionName = typeof optionRaw === 'string'
              ? optionRaw
              : (optionRaw && optionRaw.name) ? optionRaw.name : ('אפשרות ' + (optIndex + 1));

            if(product.variants.length === 1 && optionName === 'Title') return;

            const allValues = [];
            product.variants.forEach(function(v){
              const val = v.options[optIndex];
              if(val && allValues.indexOf(val) === -1) allValues.push(val);
            });

            const group = document.createElement('div');
            group.className = 'look-quick-add__option';
            group.innerHTML = '<p class="look-quick-add__option-label"><span class="look-quick-add__option-name">' + optionName + '</span>: <strong data-look-selected="' + optIndex + '"></strong></p>';

            const valuesWrap = document.createElement('div');
            valuesWrap.className = 'look-quick-add__option-values';

            allValues.forEach(function(value){
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'look-quick-add__swatch';
              btn.textContent = value;
              btn.setAttribute('data-look-opt-index', optIndex);
              btn.setAttribute('data-look-opt-value', value);
              btn.addEventListener('click', function(){
                state.selections[optIndex] = value;
                updateVariant();
              });
              valuesWrap.appendChild(btn);
            });

            group.appendChild(valuesWrap);
            optionsContainer.appendChild(group);

            if(allValues.length){
              state.selections[optIndex] = allValues[0];
            }
          });
        }

        updateVariant();
      };

      const updateVariant = function(){
        const modal = findModal();
        const state = modal.__state;
        if(!state) return;
        const product = state.product;

        const wanted = product.options.map(function(_, i){ return state.selections[i]; });
        const variant = product.variants.find(function(v){
          return v.options.every(function(opt, i){ return opt === wanted[i]; });
        });

        state.variant = variant;

        product.options.forEach(function(_, optIndex){
          const label = modal.querySelector('[data-look-selected="' + optIndex + '"]');
          if(label) label.textContent = state.selections[optIndex] || '';
        });

        modal.querySelectorAll('.look-quick-add__swatch').forEach(function(btn){
          const optIdx = parseInt(btn.getAttribute('data-look-opt-index'), 10);
          const val = btn.getAttribute('data-look-opt-value');
          btn.classList.toggle('is-active', state.selections[optIdx] === val);

          const wantedCheck = wanted.slice();
          wantedCheck[optIdx] = val;
          const anyAvailable = product.variants.some(function(v){
            return v.options.every(function(o, i){ return o === wantedCheck[i]; }) && v.available;
          });
          btn.classList.toggle('is-unavailable', !anyAvailable);
        });

        const priceEl = modal.querySelector('[data-look-price]');
        if(variant){
          let html = fmt(variant.price);
          if(variant.compare_at_price && variant.compare_at_price > variant.price){
            html = '<del>' + fmt(variant.compare_at_price) + '</del>' + html;
          }
          priceEl.innerHTML = html;
        } else {
          priceEl.textContent = fmt(product.price);
        }

        const submit = modal.querySelector('[data-look-submit]');
        const submitText = modal.querySelector('[data-look-submit-text]');
        if(!variant){
          submit.disabled = true;
          submitText.textContent = 'הצירוף לא זמין';
        } else if(!variant.available){
          submit.disabled = true;
          submitText.textContent = 'אזל מהמלאי';
        } else {
          submit.disabled = false;
          submitText.textContent = 'הוסף לסל';
        }
      };

      const closeModal = function(){
        const modal = findModal();
        if(!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('look-modal-open');
        setTimeout(function(){
          modal.setAttribute('hidden', '');
          if(modal.__state){
            modal.__state = null;
          }
        }, 300);
      };

      const addVariantToCart = async function(variantId, quantity, submitBtn){
        if(submitBtn){
          submitBtn.disabled = true;
          submitBtn.querySelector('[data-look-submit-text]').textContent = '...מוסיף';
        }
        try{
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] })
          });
          if(!res.ok){
            const data = await res.json().catch(function(){ return {}; });
            throw new Error(data.description || 'add-failed');
          }

          if(submitBtn){
            submitBtn.classList.add('is-success');
            submitBtn.querySelector('[data-look-submit-text]').textContent = '✓ נוסף לסל';
          }

          ['cart:refresh','cart:updated','cart:item-added','on:cart:add','ajaxProduct:added','product:added']
            .forEach(function(name){
              document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { variantId } }));
            });

          const drawer = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer, .cart-drawer, [data-cart-popup]');
          if(drawer){
            if(typeof drawer.open === 'function') drawer.open();
            else if(drawer.classList) drawer.classList.add('is-open','active','open','drawer--open');
          }

          try{
            const cartRes = await fetch('/cart.js');
            if(cartRes.ok){
              const cart = await cartRes.json();
              document.querySelectorAll('[data-cart-count], #cart-icon-bubble [aria-hidden], .cart-count, .cart-icon__count')
                .forEach(function(el){ el.textContent = cart.item_count; });
            }
          } catch(e){}

          setTimeout(function(){
            closeModal();
            if(submitBtn){
              submitBtn.classList.remove('is-success');
              submitBtn.querySelector('[data-look-submit-text]').textContent = 'הוסף לסל';
              submitBtn.disabled = false;
            }
          }, 1200);

          return true;
        } catch(err){
          if(submitBtn){
            submitBtn.disabled = false;
            submitBtn.querySelector('[data-look-submit-text]').textContent = 'הוסף לסל';
          }
          return false;
        }
      };

      document.addEventListener('click', async function(e){
        const btn = e.target.closest('.look-section__bag');
        if(!btn) return;
        if(btn.disabled || btn.classList.contains('is-loading')) return;

        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute('data-look-add');
        const productUrl = btn.getAttribute('data-look-url') || '#';
        const isMulti = btn.getAttribute('data-look-multi') === 'true';
        const handle = btn.getAttribute('data-look-handle');

        if(isMulti && handle){
          await openModal(handle, productUrl, variantId);
          return;
        }

        if(!isMulti && variantId){
          btn.classList.add('is-loading');
          await addVariantToCart(variantId, 1);
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          setTimeout(function(){ btn.classList.remove('is-success'); }, 1800);
          return;
        }

        window.location.href = productUrl;
      }, true);

      document.addEventListener('click', function(e){
        if(e.target.closest('[data-look-close]')){ closeModal(); return; }

        const qtyBtn = e.target.closest('[data-look-qty]');
        if(qtyBtn){
          const modal = findModal();
          const input = modal.querySelector('[data-look-qty-input]');
          const delta = parseInt(qtyBtn.getAttribute('data-look-qty'), 10);
          const cur = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, cur + delta);
          return;
        }
      });

      document.addEventListener('submit', async function(e){
        const form = e.target.closest('[data-look-form]');
        if(!form) return;
        e.preventDefault();

        const modal = findModal();
        const state = modal.__state;
        if(!state || !state.variant) return;

        const qty = parseInt(modal.querySelector('[data-look-qty-input]').value, 10) || 1;
        const submit = modal.querySelector('[data-look-submit]');
        await addVariantToCart(state.variant.id, qty, submit);
      });

      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape'){
          const modal = findModal();
          if(modal && modal.classList.contains('is-open')) closeModal();
        }
      });
    }

    sections.forEach(function(section){
      /* Parallax */
      if(!reduced){
        const inner = section.querySelector('.look-section__visual-inner');
        if(inner){
          let raf = 0, visible = false;
          const io = new IntersectionObserver(function(es){
            es.forEach(function(e){ visible = e.isIntersecting; });
          }, { threshold: 0 });
          io.observe(section);

          const tick = function(){
            raf = 0;
            if(!visible || isMobile()){
              section.style.setProperty('--ls-image-transform', '0%');
              return;
            }
            const r = section.getBoundingClientRect();
            const vh = innerHeight || document.documentElement.clientHeight;
            const progress = clamp((vh - r.top) / (vh + r.height), 0, 1);
            const shift = (progress - 0.5) * -10;
            section.style.setProperty('--ls-image-transform', shift.toFixed(2) + '%');
          };
          const onScroll = function(){ if(!raf) raf = requestAnimationFrame(tick); };
          addEventListener('scroll', onScroll, { passive: true });
          addEventListener('resize', onScroll, { passive: true });
          tick();
        }
      }

      /* Mobile carousel */
      const track = section.querySelector('[data-look-track]');
      const prev = section.querySelector('[data-look-prev]');
      const next = section.querySelector('[data-look-next]');
      const counter = section.querySelector('[data-look-counter]');
      if(!track || !prev || !next) return;

      const cards = Array.from(track.children);
      if(cards.length <= 1) return;

      const isRtl = getComputedStyle(track).direction === 'rtl';

      const getStep = function(){
        if(cards.length < 2) return track.clientWidth;
        return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
      };

      const getIndex = function(){
        const step = getStep() || 1;
        return clamp(Math.round(Math.abs(track.scrollLeft) / step), 0, cards.length - 1);
      };

      const update = function(){
        const i = getIndex();
        if(counter) counter.textContent = (i + 1) + '/' + cards.length;
        prev.disabled = i <= 0;
        next.disabled = i >= cards.length - 1;
      };

      const goTo = function(i){
        const c = clamp(i, 0, cards.length - 1);
        const step = getStep();
        const target = c * step;
        track.scrollTo({ left: isRtl ? -target : target, behavior: 'smooth' });
      };

      prev.addEventListener('click', function(){ goTo(getIndex() - 1); });
      next.addEventListener('click', function(){ goTo(getIndex() + 1); });

      let sraf = 0;
      track.addEventListener('scroll', function(){
        if(!sraf) sraf = requestAnimationFrame(function(){ sraf = 0; update(); });
      }, { passive: true });
      addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
